import React from 'react';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    const baseStyles = "px-6 py-2 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2";

    const variants = {
        primary: "bg-primary text-white hover:bg-opacity-90 shadow-lg hover:shadow-xl focus:ring-primary",
        secondary: "bg-accent text-white hover:bg-opacity-90 shadow-md hover:shadow-lg focus:ring-accent",
        outline: "border-2 border-primary text-primary hover:bg-primary hover:text-white focus:ring-primary",
    };

    return (
        <button
            className={`${baseStyles} ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
